import {
  Document,
  Link,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { IndexRow } from "./flattenFolderHierarchy";
import { PdfFileIcon, PdfFolderIcon } from "./PdfFileIcon";

export type DataRoomIndexPdfMeta = {
  dealName: string;
  exportedAt: string;
  indexingEnabled: boolean;
};

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: "Helvetica",
    fontSize: 10,
    color: "#1f2937",
  },
  header: {
    marginBottom: 24,
    borderBottomWidth: 1,
    borderBottomColor: "#e5e7eb",
    paddingBottom: 12,
  },
  title: {
    fontSize: 16,
    fontFamily: "Helvetica-Bold",
    marginBottom: 4,
  },
  subtitle: {
    fontSize: 10,
    color: "#6b7280",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 4,
  },
  index: {
    fontSize: 9,
    color: "#6b7280",
    marginRight: 6,
  },
  iconContainer: {
    marginRight: 6,
  },
  link: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    color: "#1d4ed8",
    textDecoration: "underline",
    flex: 1,
  },
});

function IndexRowView(props: {
  row: IndexRow;
  indexingEnabled: boolean;
}) {
  const { row, indexingEnabled } = props;

  return (
    <View style={[styles.row, { paddingLeft: row.depth * 12 }]}>
      {indexingEnabled && row.index ? (
        <Text style={styles.index}>{row.index}</Text>
      ) : null}
      <View style={styles.iconContainer}>
        {row.type === "folder" ? (
          <PdfFolderIcon />
        ) : (
          <PdfFileIcon fileType={row.fileType!} />
        )}
      </View>
      <Link src={row.url} style={styles.link}>
        {row.name}
      </Link>
    </View>
  );
}

export function DataRoomIndexPdfDocument(props: {
  rows: IndexRow[];
  meta: DataRoomIndexPdfMeta;
}) {
  const { rows, meta } = props;

  return (
    <Document title={`${meta.dealName} - Data Room Index`}>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.title}>{meta.dealName}</Text>
          <Text style={styles.subtitle}>Data Room Index</Text>
          <Text style={styles.subtitle}>Exported {meta.exportedAt}</Text>
        </View>
        {rows.map((row, index) => (
          <IndexRowView
            key={`${row.type}-${row.url}-${index}`}
            row={row}
            indexingEnabled={meta.indexingEnabled}
          />
        ))}
      </Page>
    </Document>
  );
}
